import React, { useCallback, useState } from "react";
import { FilesTable } from "./FilesTable.js";
import { useEntryView } from "./ViewProvider.js";
import { Form } from "../../../../packages/ui/form/Form.js";
import { FormRow } from "../../../../packages/ui/form/FormRow.js";
import { Alert } from "../../../../packages/ui/Alert.js";
import { FilesInput } from "../../../../packages/ui/form/FilesInput.js";
import { generateUuid } from "../../../../generate-uuid/generateUuid.js";

/**
 * Renders the block of files under the entry form.
 */
export const Files = () => {
  const { files, uploadFiles, isUploading, uploadError } = useEntryView();

  const [inputKey, setInputKey] = useState(() => generateUuid());

  const handleUploadFiles = useCallback(
    async (files: FileList) => {
      await uploadFiles(files);
      setInputKey(generateUuid());
    },
    [uploadFiles]
  );

  return (
    <>
      {files.length > 0 && <FilesTable />}
      <Form>
        {files.length === 0 && (
          <FormRow columns={1}>
            <Alert>Sisestusel puuduvad failid.</Alert>
          </FormRow>
        )}
        {isUploading && (
          <FormRow columns={1}>
            <Alert>Fail(id) laetakse üles ...</Alert>
          </FormRow>
        )}
        <FormRow columns={1}>
          <FilesInput
            label="Vali failid"
            accept=".png,.jpg,.jpeg,.pdf,.odf,.doc,.docx,.zip"
            onChange={handleUploadFiles}
            inputKey={inputKey}
          />
        </FormRow>
      </Form>
      {uploadError && <Alert type="error">{uploadError}</Alert>}
    </>
  );
};
